import { render, staticRenderFns } from "./GmbsList.vue?vue&type=template&id=53908be6&scoped=true&"
import script from "./GmbsList.vue?vue&type=script&lang=js&"
export * from "./GmbsList.vue?vue&type=script&lang=js&"
import style0 from "./GmbsList.vue?vue&type=style&index=0&id=53908be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53908be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53908be6')) {
      api.createRecord('53908be6', component.options)
    } else {
      api.reload('53908be6', component.options)
    }
    module.hot.accept("./GmbsList.vue?vue&type=template&id=53908be6&scoped=true&", function () {
      api.rerender('53908be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gmbs/GmbsList.vue"
export default component.exports